import { Injectable } from '@angular/core';
import { giata } from 'libraries/hotel/containers/hotels-list/config';
import {IAlternative, IGeoposition} from 'libraries/hotel/models/hotel';
import { ISimpleSelectOption } from 'libraries/module/formbuilder/fields/simple-select/simple-select.interface';
import { IProperty } from 'libraries/service/resources/hotel/ISearchResponse';
import { Observable } from "rxjs";
import { SearchHotelFormService } from "libraries/hotel/containers/search-hotel-form/services/search-hotel-form.service";
import { map, switchMap } from "rxjs/operators";
import { HostAliasResource, IHostAlias } from "libraries/service/resources/host-alias/host-alias.resource";
import { IHotelProperty } from "libraries/service/resources/model/search/hotel/IHotelProperty";
import { IDescriptionObject } from "libraries/hotel/models/details";
import { Yii } from "libraries/interfaces/Yii";

@Injectable()
export class HotelInformationsModalService {

    constructor(
        private readonly searchHotelFormService: SearchHotelFormService,
        private readonly hostAliasResource: HostAliasResource,
    ) {
    }

    public getAlternativesOptions(
        alternatives: IAlternative[],
        hostsConfig: IHostAlias[],
        isWithGiata: boolean,
        onHostOrGiataChoice: boolean = false,
        sourceCode: string = null,
    ): ISimpleSelectOption[] {
        const simpleSelectOptions: ISimpleSelectOption[] = [
            // {
            //     value: null,
            //     label: Yii.t('wui-shared-js', 'Choisissez un fournisseur'),
            // }
        ];
        const sourceHost: IAlternative = alternatives.find((alternative: IAlternative): boolean => alternative.hostCode === sourceCode);
        if (onHostOrGiataChoice && sourceCode !== giata && sourceHost) {

            simpleSelectOptions.push({
                value: sourceHost.syscode,
                label: this.hostAliasResource.findAliasFromList(hostsConfig, sourceHost.hostCode)
            });
        } else if (!onHostOrGiataChoice) {
            alternatives.forEach((alternative: IAlternative) => {
                if (hostsConfig.map((hostAlias: IHostAlias) => hostAlias.host).includes(alternative.hostCode.toUpperCase())) {
                    simpleSelectOptions.push({
                        value: alternative.syscode,
                        label: this.hostAliasResource.findAliasFromList(hostsConfig, alternative.hostCode)
                    });
                }
            });
        }

        if (isWithGiata) {
            const hostGiata: IAlternative = alternatives
                .find((alternative: IAlternative) => alternative.hostCode === giata);
            if(hostGiata){
                simpleSelectOptions.push({value: hostGiata.syscode, label: hostGiata.hostCode});
            }
        }

        return simpleSelectOptions.sort((a: ISimpleSelectOption, b: ISimpleSelectOption) => a.label.localeCompare(b.label));
    }

    public hasDifferentLanguage(hotelProperty: IHotelProperty, wenjiLanguage: string): boolean {
        // console.log(hotelProperty, wenjiLanguage)
        const lowerWenjiLanguage: string = wenjiLanguage.toLowerCase();

        const allLanguageCodes: string[] = [];
        allLanguageCodes.push(hotelProperty.languageCode);
        if (hotelProperty.introduction) {
            allLanguageCodes.push(hotelProperty.introduction.languageCode);
        }
        if (hotelProperty.descriptions) {
            allLanguageCodes.push(...hotelProperty.descriptions.map((desc: IDescriptionObject) => desc.languageCode));
        }
        // console.log(allLanguageCodes)
        const withDiffferentLanguage: boolean = allLanguageCodes
            .filter(Boolean)
            .map((value: string) => value.toLowerCase())
            .some((value: string) => value !== lowerWenjiLanguage);

        return withDiffferentLanguage;
    }

    public changeHotelPropertyAfterGetProperty(oldHotelProperty: IProperty, newHotelProperty: IProperty): IProperty {
        return {
            ...oldHotelProperty,
            descriptions: newHotelProperty.descriptions,
            introduction: newHotelProperty.introduction,
            credit: newHotelProperty.credit,
            media: newHotelProperty.media,
            medias: newHotelProperty.medias,
            name: newHotelProperty.name,
            address: newHotelProperty.address,
            sites: newHotelProperty.sites,
            geoposition: this.getGeoposition(newHotelProperty),
            keyword: newHotelProperty.keyword,
            telephones: newHotelProperty.telephones,
            rating: newHotelProperty.rating,
            languageCode: newHotelProperty.languageCode,
        };
    }

    public getGeoposition(property: IProperty): IGeoposition | null {
        return property.geoposition ?? (property.latitude && property.longitude ? {
            latitude: property.latitude.toString(),
            longitude: property.longitude.toString()
        } as unknown as IGeoposition : null);
    }

    public getAlternativesOptionsObservable(alternatives: IAlternative[], isWithGiata: boolean, onHostOrGiataChoice: boolean, sourceCode: string)
        : Observable<ISimpleSelectOption[]> {

        return this.searchHotelFormService.getFormHotelData()
            .pipe(
                switchMap((config: { hosts: string[] }) => this.hostAliasResource.getAliases(config.hosts)),
                map((hostAliases: IHostAlias[]) =>
                    this.getAlternativesOptions(alternatives, hostAliases, isWithGiata, onHostOrGiataChoice, sourceCode))
            );
    }
}
